
    const data = {"name":"src/core/icons/content-save-check","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M17 3H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h6.81c-.39-.66-.64-1.4-.74-2.16a2.994 2.994 0 0 1-1.87-3.81C9.61 13.83 10.73 13 12 13c.44 0 .88.1 1.28.29 2.29-1.79 5.55-1.7 7.72.25V7l-4-4m-2 6H5V5h10v4m.75 12L13 18l1.16-1.16 1.59 1.59 3.59-3.59 1.16 1.41L15.75 21\"/>","originalColors":[],"stopColors":[]}}

            export default data
            